import API from "api/base/base";
import { appendQueryArgs } from "utils/apiHelpers";
import { axios } from "utils/axios";

const User = new API({ controller: "user" });

Object.assign(User, {
  getUserData() {
    return axios.get(`${this.url}/user_data`);
  },
  getPosts(payload) {
    return axios.get(appendQueryArgs(`${this.url}/posts`, payload));
  },

  getDownloads(payload) {
    return axios.get(appendQueryArgs(`${this.url}/downloads`, payload));
  },
});

export default User;
